import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ArticleCode } from 'src/app/models/article-code/article-code.model';
import { AuthService } from '../../authentication/auth.service';
import { BaseApiService } from '../../base-api.service';
import { TranslateFirebaseService } from '../../utils/translate-firebase.service';

@Injectable()
export class RestArticleCodeService extends BaseApiService {

  constructor(httpClient: HttpClient,
    translate : TranslateFirebaseService,
    private authService : AuthService) {
    super(httpClient, translate);
  }

  createArticleCode(articleCode: ArticleCode): Observable<ArticleCode> {
    return this.httpClient.post<ArticleCode>(super.getUpsApiHost() + "Articles", articleCode, {headers : this.authService.upsHttpHeaders});
  }

  updateArticleCode(articleCode: ArticleCode): Observable<ArticleCode> {
    return this.httpClient.put<ArticleCode>(super.getUpsApiHost() + "Articles/" + articleCode.id, articleCode, {headers : this.authService.upsHttpHeaders});
  }

  deleteArticleCode(id: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(super.getUpsApiHost() + "Articles/" + id, {headers : this.authService.upsHttpHeaders});
  }

  getArticleCodeById(id: number) : Observable<ArticleCode> {
    return this.httpClient.get<ArticleCode>(super.getUpsApiHost() + "Articles/" + id, { headers: this.authService.upsHttpHeaders });
  }

  getAllArticleCodes(): Observable<ArticleCode[]> {
    return this.httpClient.get<ArticleCode[]>(super.getUpsApiHost() + 'Articles', { headers: this.authService.upsHttpHeaders });
  }

  getAllArticleCodesByFamilyId(familyId: number): Observable<ArticleCode[]> {
    return this.httpClient.get<ArticleCode[]>(super.getUpsApiHost() + 'Articles/DeviceTypeFamily/' + familyId, { headers: this.authService.upsHttpHeaders });
  }
}
